var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['base-step', _vm.classStep],on:{"click":function($event){return _vm.goToStep()}}},[_c('div',[_vm._v(" "+_vm._s(_vm.contentStep.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }